var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rounded-lg" },
    [
      _c("label", { staticClass: "typo__label h2--background mr-3 d-none" }, [
        _vm._v("Standort:")
      ]),
      _vm._v(" "),
      _c("multiselect", {
        ref: "merchantSelect",
        staticClass: "rounded-0",
        attrs: {
          "allow-empty": false,
          disabled: _vm.isDisabled,
          "group-select": false,
          multiple: false,
          options: this.wholesalerMerchantData,
          "preselect-first": true,
          searchable: true,
          "deselect-label": "Dieser Wert kann nicht entfernt werden.",
          "group-label": "wholesaler",
          "group-values": "merchants",
          label: "name",
          placeholder: "Standort auswählen ...",
          "track-by": "name"
        },
        on: { close: _vm.updateSelectedMerchant },
        model: {
          value: _vm.contactValue,
          callback: function($$v) {
            _vm.contactValue = $$v
          },
          expression: "contactValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }